import { createContext, useMemo, ReactNode } from 'react';

interface DirectToVdpContextInfo {
  isDirectToVdp?: boolean;
}

const DirectToVdpContext = createContext<DirectToVdpContextInfo>({});

export function DirectToVdpProvider({
  children,
  isDirectToVdp,
}: {
  children: ReactNode;
  isDirectToVdp: boolean;
}): JSX.Element {
  const value = useMemo(() => ({ isDirectToVdp }), [isDirectToVdp]);

  return <DirectToVdpContext.Provider value={value}>{children}</DirectToVdpContext.Provider>;
}

export default DirectToVdpContext;
